import {SET_DATA_PIN_CODES} from '../actions/pinCodes';

const initialState = {
	"pin_purchase": {
    "status": 0
  },
  "pin_parental": {
    "status": 0
  },
  "pin_channel": {
    "status": 0
  }
}

function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_DATA_PIN_CODES:
      return {...state, ...action.data};

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/pinCodes.js